import {
  HostListener,
  Component,
  OnInit,
  AfterContentChecked,
  Output,
  EventEmitter,
  ViewChild,
  ElementRef,
} from "@angular/core";
import { Observable } from "rxjs/Observable";
import { NgbModal, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";

import { ErrorObject } from "../../app/errorhandler/gpiserror-object";
import { ErrorHandlerService } from "../../app/errorhandler/gpiserror-handler.service";
import { IReturnObject } from "../shared/return-object.model";
import { ErrorTypeEnum, StatusEnum } from "../shared/enums.model";
import { AttributeListBE } from "../shared/attribute-list.model";
import { ComponentCanDeactivate } from "../../app/shared/page.pendingchangesguard";
import { PackagingMaterialAttirbuteService } from "./packaging-material-attributes.service";
import { UserHandling } from "../shared/user-handling";
import { ConfirmResult } from "../../app/dialogboxes/shared/confirm.model";
import { SetFocus } from "../../app/shared/setFocus";
import { PArray } from "../shared/packit-array";
import { PackagingMaterialListBE } from "../../app/packaging-material/shared/packaging-material.model";
import { PackageInstructionAdditionalMHBE } from "../../app/packaging-instruction/shared/packaging-instruction-material.model";
import { PackagingMaterialService } from "../../app/packaging-material/packaging-material.service";
import { SupplierContactComponent } from "../supplier-contact/supplier-contact.component";
import { SupplierContactService } from '../supplier-contact/supplier-contacts.service';
import { SupplierService } from '../../app/supplier/supplier.service';
import { SupplierContactBE, SupplierListBE } from "../supplier/shared/supplier.model";
import { ChineseChangeValueService } from "../chinese-change-value.service";

@Component({
  moduleId: module.id,
  selector: "packaging-material-attributes",
  templateUrl: "packaging-material-attributes.html",
  providers: [PackagingMaterialAttirbuteService, PackagingMaterialService, SupplierContactService, SupplierService],
})
export class PackagingMaterialAttributeComponent
  implements OnInit, AfterContentChecked, ComponentCanDeactivate {
  @Output() materialExecuteCommand: EventEmitter<number> = new EventEmitter<
    number
  >();
  @Output() materialDlgExecuteCommand: EventEmitter<
    PackagingMaterialListBE[]
  > = new EventEmitter<PackagingMaterialListBE[]>();

  selectedRow: number;
  isDirty: boolean = false;
  errorObj: ErrorObject = null;
  showLoadListsSpinner: boolean = false;

  showSpinner: boolean = false;
  viewSupplierListSpinner: boolean = false;

  supplierList: SupplierListBE[];
  suppliercontactlist: SupplierListBE[];
  supplierContacts: SupplierContactBE[];
  selectedSupplierName: string = "";
  extendedsuppliername: string = "";
  selectedSupplierId: number = 0;
  isSelectedSupplierInfoExpired: boolean = false;

  selectionNo: number = 2;

  // supplier search
  searchSupplierText: string = "";
    viewSupplierList: boolean = false;
    searchKeyStrokeDelay: number = 350;
    typeDelayTimer: any = null;
    supplierSearchListDelayTimer: any = null;
    searchListDelayTimerDelay: number = 250;


  // Lists
  classificationsList: AttributeListBE[] = [];
  consumingAreasList: AttributeListBE[] = [];
  dispatchersList: AttributeListBE[] = [];
  mainStoresList: AttributeListBE[] = [];
  materialTypesList: AttributeListBE[] = [];
  packagingOwnersList: AttributeListBE[] = [];
  packagingTypesList: AttributeListBE[] = [];
  receiversList: AttributeListBE[] = [];
  regionsList: AttributeListBE[] = [];
  returnablesList: AttributeListBE[] = [];
  storageConditionsList: AttributeListBE[] = [];
  washingSuppliersList: AttributeListBE[] = [];
  materialExclusionList: AttributeListBE[] = [];
  materialList: AttributeListBE[] = [];

  // Current tab
  currentList: AttributeListBE[] = [];
  currentListText: string = "";
  attributeDescription: string = "";
  attributeSupplierName: string = "";
  attributeCO2Impact: number = 0;
  suppliernumber: number = 0;
  attributeActive: boolean = true;
  attributeId: number = 0;
  materialId: number = 0;
  MHNo: string = "";
  currentAttribute: string = "classifications";
  currentAttributeId: number = -1;
  attributeDescriptionDisabled: boolean = true;
  attributeCO2ImpactDisabled: boolean = true;
  attributeSupplierNameDisabled: boolean = true;
  attributeMainstoreDisabled: boolean = true;
  deletematerialExclusion: number = 0;
  public selectedMHno: any;

  // confirm dialog
  @ViewChild("cDlg") cdlg: ElementRef;
  dialogAction: string;
  dialogBtnType: string;
  dialogAppliesTo: string = "";
  dialogAppliesToId: number = -1;
  confirmDlgText: string = "";
  currentDlg: NgbModalRef;

  // misc
  user: UserHandling = new UserHandling();
  saveUpdateBtnText: string = "";
  saveUpdateBtnIcon: string = "";
  isInEditMode: boolean = false;
  isInNewMode: boolean = false;
  isMaterialExclusion: boolean = false;
  isMaterialList: boolean = false;
  isMainStore: boolean = false;
  isWashingSupplier: boolean = false;

  setFocus: SetFocus = new SetFocus();
  isFocusSet: boolean = false;

  //Material Exclusion
  searchMaterialText: string = "";
  showCheckBoxes: boolean = false;
  showRadios: boolean = false;
  showButtons: boolean = false;
  showMaterialSearchSpinner: boolean = false;
  showDialog: boolean = true;
  editDescription: boolean = true;
  materialSearchResult: PArray<PackagingMaterialListBE> = new PArray(
    new Array<PackagingMaterialListBE>()
  );
  selectedMaterialsPArr: PArray<PackagingMaterialListBE> = new PArray(
    new Array<PackagingMaterialListBE>()
  );
  isAlreadyAddedPArr: PArray<PackageInstructionAdditionalMHBE> = null;

  searchMaterialTextChanged() {
    var that = this; // needed to preserve scope reference to this within setinterval function

    if (this.searchMaterialText.length > 1) {
      // If this.typeDelayTimer is not nulll then the
      // user typed somthing new within time limit so reset timer
      if (this.typeDelayTimer != null) clearInterval(this.typeDelayTimer);

      this.typeDelayTimer = setInterval(function () {
        that.searchMaterial();
      }, this.searchKeyStrokeDelay);
    } else {
      this.materialSearchResult = new PArray(
        new Array<PackagingMaterialListBE>()
      );
      clearInterval(this.typeDelayTimer);
    }
  }

  searchResult() {
    if (this.materialSearchResult != null && this.searchMaterialText.length > 1)
      return this.materialSearchResult.Array();
    else return [];
  }

  isChecked(materialId: number): boolean {
    let inx = this.selectedMaterialsPArr.getIndexByProperty("Id", materialId);
    return inx != null;
  }

  isAlreadySelected(materialId: number): boolean {
    let inx =
      this.isAlreadyAddedPArr != null
        ? this.isAlreadyAddedPArr.getIndexByProperty("MaterialId", materialId)
        : null;
    return inx != null;
  }

  setSelectedMaterial(material: PackagingMaterialListBE): void {
    this.attributeDescription = material.Description;
    this.MHNo = material.MHNo;

    if (this.showButtons) {
      this.editMaterial(material.Id);
    } else if (this.showRadios) {
      this.selectedMaterialsPArr.pop();
      this.selectedMaterialsPArr.push(material);
    } else {
      let inx = this.selectedMaterialsPArr.indexOf(material);
      if (inx == -1) this.selectedMaterialsPArr.push(material);
      else this.selectedMaterialsPArr.removAtIndex(inx);
    }
  }

  searchMaterial() {
    this.showMaterialSearchSpinner = true;
    this.materialSearchResult = null;
    this.errorObj = null;
    clearInterval(this.typeDelayTimer);

    this.materialService
      .searchMaterial(this.searchMaterialText)
      .subscribe((returnObject) => this.searchMaterialResult(returnObject));
  }

  searchMaterialResult(returnObject: IReturnObject) {
    this.materialSearchResult = new PArray(
      new Array<PackagingMaterialListBE>()
    );
    this.selectedMaterialsPArr = new PArray(
      new Array<PackagingMaterialListBE>()
    );

    if (returnObject.ErrorType != ErrorTypeEnum.NoError)
      this.errHandler.emitError(
        returnObject.ErrorMsg,
        "MaterialSearchComponent.gsearchMaterialResult",
        returnObject.ErrorType
      );
    else this.materialSearchResult = new PArray(returnObject.DataList);

    this.showMaterialSearchSpinner = false;
  }

  editMaterial(materialId: number) {
    this.materialExecuteCommand.emit(materialId);
  }

  isNoSelection(): boolean {
    return this.selectedMaterialsPArr.Array().length == 0;
  }

  okClose() {
    this.materialDlgExecuteCommand.emit(this.selectedMaterialsPArr.Array());
  }

  constructor(
    private materialAttrService: PackagingMaterialAttirbuteService,
    private modalService: NgbModal,
    private errHandler: ErrorHandlerService,
    private materialService: PackagingMaterialService,
    private supplierService: SupplierService,
    private supplierContactService: SupplierContactService,
    private ChineseChangeValueService:ChineseChangeValueService
  ) {
    errHandler.errorEvent.subscribe((err: ErrorObject) => this.onError(err));
  }

  ngOnInit() {
    this.showLoadListsSpinner = true;
    this.getClassifications();
    this.currentListText = "Classification";
    this.currentAttribute == "classifications";
    if ((this.user.IsPartSupplierUser || this.user.IsPackagingEngineer || this.user.IsPackagingAdmin)) {
            if (this.user.SupplierNumber != null) {
                if (this.user.SupplierNumber !== 'undefined') {
                    this.getSupplierBySupplierNo(this.user.SupplierNumber, this.user.ExtendedSupplierNumber);
                }
            }
        }
  }

  ngAfterContentChecked() {
    this.isFocusSet = this.setFocus.to("attributeList", this.isFocusSet);
  }

  @HostListener("window:beforeunload")
  canDeactivate(): Observable<boolean> | boolean {
    return !this.isDirty;
  }

  // ----------------------------------------------------------
  // Fetch list data
  // ----------------------------------------------------------
  getPackagingTypes() {
    this.errHandler.emitErrorObject(null);
    this.materialAttrService
      .getPackagingTypes()
      .subscribe((returnObject) =>
        this.getAttributesResponse(returnObject, this.packagingTypesList, false)
      );
  }

  getPackagingOwners() {
    this.errHandler.emitErrorObject(null);
    this.materialAttrService
      .getPackagingOwners()
      .subscribe((returnObject) =>
        this.getAttributesResponse(
          returnObject,
          this.packagingOwnersList,
          false
        )
      );
  }

  getStorageConditions() {
    this.errHandler.emitErrorObject(null);
    this.materialAttrService
      .getStorageConditions()
      .subscribe((returnObject) =>
        this.getAttributesResponse(
          returnObject,
          this.storageConditionsList,
          false
        )
      );
  }

  getReturnables() {
    this.errHandler.emitErrorObject(null);
    this.materialAttrService
      .getReturnables()
      .subscribe((returnObject) =>
        this.getAttributesResponse(returnObject, this.returnablesList, false)
      );
  }

  getClassifications() {
    this.errHandler.emitErrorObject(null);
    this.materialAttrService
      .getClassifications() // fixa i materials ocs
      .subscribe((returnObject) =>
        this.getAttributesResponse(
          returnObject,
          this.classificationsList,
          false
        )
      );
  }

  getDispatchers() {
    this.errHandler.emitErrorObject(null);
    this.materialAttrService
      .getDispatchers()
      .subscribe((returnObject) =>
        this.getAttributesResponse(returnObject, this.dispatchersList, false)
      );
  }

  getWashingSuppliers() {
    this.errHandler.emitErrorObject(null);
    this.materialAttrService
      .getWashingSuppliers()
      .subscribe((returnObject) =>
        this.getAttributesResponse(
          returnObject,
          this.washingSuppliersList,
          false
        )
      );
  }

  getMaterialExclusions() {
    this.errHandler.emitErrorObject(null);
    this.materialAttrService
      .getMaterialExclusions()
      .subscribe((returnObject) =>
        this.getAttributesResponse(
          returnObject,
          this.materialExclusionList,
          true
        )
      );
  }

  getMainStores() {
    this.errHandler.emitErrorObject(null);
    this.materialAttrService
      .getMainStores()
      .subscribe((returnObject) =>
        this.getAttributesResponse(returnObject, this.mainStoresList, false)
      );
  }

  getConsumingAreas() {
    this.errHandler.emitErrorObject(null);
    this.materialAttrService
      .getConsumingAreas()
      .subscribe((returnObject) =>
        this.getAttributesResponse(returnObject, this.consumingAreasList, false)
      );
  }

  getMaterialList() {
    this.errHandler.emitErrorObject(null);
    this.materialAttrService
      .getMaterialList()
      .subscribe((returnObject) =>
        this.getAttributesResponse(
          returnObject,
          this.materialList,
          false
        )
      );
  }

  getRegions() {
    this.errHandler.emitErrorObject(null);
    this.materialAttrService
      .getRegions()
      .subscribe((returnObject) =>
        this.getAttributesResponse(returnObject, this.regionsList, false)
      );
  }

  getAttributesResponse(
    returnObject: IReturnObject,
    list: AttributeListBE[],
    isExclude: boolean
  ) {
    if (returnObject.ErrorType != ErrorTypeEnum.NoError)
      this.errHandler.emitError(
        returnObject.ErrorMsg,
        "PackagingMaterialAttributeComponent.getMaterialTypesResponse",
        returnObject.ErrorType
      );
    else {
      this.currentList = new Array<AttributeListBE>();
      list = returnObject.DataList;
      let that = this;
      list.forEach(function (item) {
        if (item.Id >= 1) that.currentList.push(item);
      });
      this.attributeId =
        this.currentList.length > 0 ? this.currentList[0].Id : null;
      this.attributeDescription = "";
    }
    this.showLoadListsSpinner = false;
    this.isFocusSet = false;
    this.isFocusSet = this.setFocus.to("attributeList", this.isFocusSet);

    if (isExclude === true) this.materialExclusionList = list;
  }

  // ----------------------------------------------------------
  // Actions
  // ----------------------------------------------------------
  cancel() {
    this.setAttributeDescriptionInput();
    this.isInEditMode = false;
  }

  add() {
    this.isInEditMode = true;
    this.saveUpdateBtnText = "Add";
    this.saveUpdateBtnIcon = "plus";
    this.currentAttributeId = -1;
    this.attributeDescriptionDisabled = false;
    this.attributeDescription = "";
    this.attributeSupplierName = "";
    this.selectedSupplierName = "";
    this.searchSupplierText = "";
    this.attributeCO2Impact = 0;
    this.attributeActive = true;
    this.editDescription = true;
    this.selectedSupplierId = 0;
    this.setDescriptionInputFocus();
  }

  edit() {
    this.isInEditMode = true;
    this.editDescription = false;
    this.saveUpdateBtnText = "Save";
    this.saveUpdateBtnIcon = "save";
    this.attributeSupplierName = "";
    let itm: AttributeListBE = this.currentList.find(
      (x) => x.Id == this.attributeId
    );
    this.currentAttributeId = this.attributeId;
    this.attributeDescriptionDisabled = false;
    this.attributeDescription = itm.Description;
    this.attributeCO2Impact = itm.CO2Impactperkg;
    this.attributeSupplierName = itm.SupplierName;
    
    this.attributeActive = itm.Active;
    if(this.isMaterialList)
    this.attributeCO2ImpactDisabled = false;
    if(this.isMainStore)
    {
      this.attributeSupplierNameDisabled = false;
      this.searchSupplierText = "";
      this.selectedSupplierName = ""; 
    }
    
    if(this.isMainStore && itm.SupplierName !=  null)
    {
      this.selectedSupplierName = itm.SupplierName;;
    }

    this.setDescriptionInputFocus();
  }

  setEditContext(context: string) {
    this.showLoadListsSpinner = true;
    this.attributeDescriptionDisabled = true;
    if(this.isMaterialList)
    this.attributeCO2ImpactDisabled = true;
    if(this.isMainStore)
    this.attributeSupplierNameDisabled = true;
    this.attributeId = null;

    if (context == "classifications") {
      this.getClassifications();
      this.currentListText = "Classification";
      this.isMaterialExclusion = false;
      this.isMaterialList = false;
      this.isMainStore = false;
      this.isWashingSupplier = false;
    } else if (context == "consumingareas") {
      this.getConsumingAreas();
      this.currentListText = "Consuming area";
      this.isMaterialExclusion = false;
      this.isMaterialList = false;
      this.isMainStore = false;
      this.isWashingSupplier = false;
    } else if (context == "dispatchers") {
      this.getDispatchers();
      this.currentListText = "Dispatcher";
      this.isMaterialExclusion = false;
      this.isMaterialList = false;
      this.isMainStore = false;
      this.isWashingSupplier = false;
    } else if (context == "mainstores") {
      this.getMainStores();
      this.currentListText = "Main store";
      this.isMaterialExclusion = false;
      this.isMaterialList = false;
      this.isMainStore = true;
      this.isWashingSupplier = false;
    } else if (context == "packagingowners") {
      this.getPackagingOwners();
      this.currentListText = "Packaging owner";
      this.isMaterialExclusion = false;
      this.isMaterialList = false;
      this.isMainStore = false;
      this.isWashingSupplier = false;
    } else if (context == "packagingtypes") {
      this.getPackagingTypes();
      this.currentListText = "Packaging type";
      this.isMaterialExclusion = false;
      this.isMaterialList = false;
      this.isMainStore = false;
      this.isWashingSupplier = false;
    } else if (context == "regions") {
      this.getRegions();
      this.currentListText = "Region";
      this.isMaterialExclusion = false;
      this.isMaterialList = false;
      this.isMainStore = false;
      this.isWashingSupplier = false;
    } else if (context == "returnables") {
      this.getReturnables();
      this.currentListText = "Returnable";
      this.isMaterialExclusion = false;
      this.isMaterialList = false;
      this.isMainStore = false;
      this.isWashingSupplier = false;
    } else if (context == "storageconditions") {
      this.getStorageConditions();
      this.currentListText = "Storage condition";
      this.isMaterialExclusion = false;
      this.isMaterialList = false;
      this.isMainStore = false;
      this.isWashingSupplier = false;
    } else if (context == "washingsuppliers") {
      this.getWashingSuppliers();
      this.currentListText = "Washing supplier";
      this.isMaterialExclusion = false;
      this.isMaterialList = false;
      this.isMainStore = true;
      this.isWashingSupplier = true;
    } else if (context == "materialexclusions") {
      this.getMaterialExclusions();
      this.isMaterialExclusion = true;
      this.isMaterialList = false;
      this.isMainStore = false;
      this.isWashingSupplier = false;
      this.currentListText =
        "\n List of Packaging Materials allowed to use multiple times in a Packaging Instruction.";
    } else if (context == "materials") {
      this.getMaterialList();
      this.currentListText = "Material List";
      this.isMaterialList = true;
      this.isMainStore = false;
      this.isMaterialExclusion = false;
      this.isWashingSupplier = false;
    }

    this.currentAttribute = context;
    if (this.currentList.length > 0) {
      this.attributeId = this.currentList[0].Id;
    }

    this.attributeDescription = "";
    this.attributeSupplierName = "";
    this.attributeCO2Impact = 0;
    this.isDirty = true;
  }

  deleteMaterialexclusion(deletelist: AttributeListBE) {
    this.openConfirmDeleteDlg();
    this.deletematerialExclusion = deletelist.Id;
  }

  highlightRow(material) {
    this.selectedMHno = material.MHNo;
  }

  delete() {
    this.openConfirmDeleteDlg();
  }
  doDelete() {
    this.errHandler.emitErrorObject(null);
    if (this.currentAttribute == "classifications") {
      this.materialAttrService
        .deleteClassification(this.attributeId)
        .subscribe((returnObject) => this.actionResponse(returnObject));
    } else if (this.currentAttribute == "consumingareas") {
      this.materialAttrService
        .deleteConsumingarea(this.attributeId)
        .subscribe((returnObject) => this.actionResponse(returnObject));
    } else if (this.currentAttribute == "dispatchers") {
      this.materialAttrService
        .deleteDispatcher(this.attributeId)
        .subscribe((returnObject) => this.actionResponse(returnObject));
    } else if (this.currentAttribute == "mainstores") {
      this.materialAttrService
        .deleteMainstore(this.attributeId)
        .subscribe((returnObject) => this.actionResponse(returnObject));
    } else if (this.currentAttribute == "materialtypes") {
      this.materialAttrService
        .deleteMaterialtype(this.attributeId)
        .subscribe((returnObject) => this.actionResponse(returnObject));
    } else if (this.currentAttribute == "packagingowners") {
      this.materialAttrService
        .deletePackagingowner(this.attributeId)
        .subscribe((returnObject) => this.actionResponse(returnObject));
    } else if (this.currentAttribute == "packagingtypes") {
      this.materialAttrService
        .deletePackagingtype(this.attributeId)
        .subscribe((returnObject) => this.actionResponse(returnObject));
    } else if (this.currentAttribute == "receivers") {
      this.materialAttrService
        .deleteReceiver(this.attributeId)
        .subscribe((returnObject) => this.actionResponse(returnObject));
    } else if (this.currentAttribute == "regions") {
      this.materialAttrService
        .deleteRegion(this.attributeId)
        .subscribe((returnObject) => this.actionResponse(returnObject));
    } else if (this.currentAttribute == "returnables") {
      this.materialAttrService
        .deleteReturnables(this.attributeId)
        .subscribe((returnObject) => this.actionResponse(returnObject));
    } else if (this.currentAttribute == "storageconditions") {
      this.materialAttrService
        .deleteStoragecondition(this.attributeId)
        .subscribe((returnObject) => this.actionResponse(returnObject));
    } else if (this.currentAttribute == "washingsuppliers") {
      this.materialAttrService
        .deleteWashingsupplier(this.attributeId)
        .subscribe((returnObject) => this.actionResponse(returnObject));
    } else if (this.currentAttribute == "materialexclusions") {
      this.materialAttrService
        .deleteMaterialexclusion(this.deletematerialExclusion)
        .subscribe((returnObject) => this.actionResponse(returnObject));
    }
    else if (this.currentAttribute == "materials") {
      this.materialAttrService
        .deleteMaterialList(this.attributeId)
        .subscribe((returnObject) => this.actionResponse(returnObject));
    }
  }

  validateExists() {
    if (this.currentAttribute != "materialexclusions") {
      if (
        this.currentAttributeId == -1 &&
        this.currentList.findIndex(
          (x) => x.Description == this.attributeDescription.trim()
        ) != -1
      ) {
        this.confirmDlgText =
          "A record with the same text already exist, cant add.";
        this.openValidateErrorDlg();
        return false;
      }
    } else if (
      this.currentAttributeId == -1 &&
      this.currentList.findIndex((x) => x.MHno == this.MHNo.trim()) != -1
    ) {
      this.confirmDlgText =
        "A record with the same MH number already exist, cant add.";
      this.openValidateErrorDlg();
      return false;
    }
    return true;
  }

  validateEmptyDescription() {
    if (this.attributeDescription.trim().length == 0) {
      this.confirmDlgText = "Description must not be empty.";
      this.openValidateErrorDlg();
      return false;
    }
    return true;
  }

  validateEmptyCO2Impact() {
    if (this.attributeCO2Impact <= 0) {
      this.confirmDlgText = "kg CO2 / kg material should be greater than 0.";
      this.openValidateErrorDlg();
      return false;
    }
    return true;
  }


  update() {
    this.errHandler.emitErrorObject(null);

    if (!this.validateExists()) return;

    if (!this.validateEmptyDescription()) return;

    if (this.isMaterialList && !this.validateEmptyCO2Impact()) return;

    if (this.currentAttribute == "classifications") {
      this.materialAttrService
        .updateClassification(
          this.currentAttributeId,
          this.attributeDescription.trim(),
          this.attributeActive
        )
        .subscribe((returnObject) => this.actionResponse(returnObject));
    } else if (this.currentAttribute == "consumingareas") {
      this.materialAttrService
        .updateConsumingarea(
          this.currentAttributeId,
          this.attributeDescription.trim(),
          this.attributeActive
        )
        .subscribe((returnObject) => this.actionResponse(returnObject));
    } else if (this.currentAttribute == "dispatchers") {
      this.materialAttrService
        .updateDispatcher(
          this.currentAttributeId,
          this.attributeDescription.trim(),
          this.attributeActive
        )
        .subscribe((returnObject) => this.actionResponse(returnObject));
    } else if (this.currentAttribute == "mainstores") {
      this.materialAttrService
        .updateMainstore(
          this.currentAttributeId,
          this.attributeDescription.trim(),
          this.selectedSupplierId,
          this.attributeActive
        )
        .subscribe((returnObject) => this.actionResponse(returnObject));
    } else if (this.currentAttribute == "packagingowners") {
      this.materialAttrService
        .updatePackagingowner(
          this.currentAttributeId,
          this.attributeDescription.trim(),
          this.attributeActive
        )
        .subscribe((returnObject) => this.actionResponse(returnObject));
    } else if (this.currentAttribute == "packagingtypes") {
      this.materialAttrService
        .updatePackagingtype(
          this.currentAttributeId,
          this.attributeDescription.trim(),
          this.attributeActive
        )
        .subscribe((returnObject) => this.actionResponse(returnObject));
    } else if (this.currentAttribute == "regions") {
      this.materialAttrService
        .updateRegion(
          this.currentAttributeId,
          this.attributeDescription.trim(),
          this.attributeActive
        )
        .subscribe((returnObject) => this.actionResponse(returnObject));
    } else if (this.currentAttribute == "returnables") {
      this.materialAttrService
        .updateReturnables(
          this.currentAttributeId,
          this.attributeDescription.trim(),
          this.attributeActive
        )
        .subscribe((returnObject) => this.actionResponse(returnObject));
    } else if (this.currentAttribute == "storageconditions") {
      this.materialAttrService
        .updateStoragecondition(
          this.currentAttributeId,
          this.attributeDescription.trim(),
          this.attributeActive
        )
        .subscribe((returnObject) => this.actionResponse(returnObject));
    } else if (this.currentAttribute == "washingsuppliers") {
      this.materialAttrService
        .updateWashingsupplier(
          this.currentAttributeId,
          this.attributeDescription.trim(),
          this.selectedSupplierId,
          this.attributeActive
        )
        .subscribe((returnObject) => this.actionResponse(returnObject));
    } else if (this.currentAttribute == "materialexclusions") {
      this.showLoadListsSpinner = true;
      this.highlightRow("");
      this.materialAttrService
        .updateMaterialexclusion(this.attributeDescription.trim(), this.MHNo)
        .subscribe((returnObject) => {
          this.actionResponse(returnObject);
        });
    } else if (this.currentAttribute == "materials") {
      this.materialAttrService
        .updateMaterialList(
          this.currentAttributeId,
          this.attributeDescription.trim(),
          this.attributeCO2Impact,
          this.attributeActive
        )
        .subscribe((returnObject) => this.actionResponse(returnObject));
    }
  }

  actionResponse(returnObject: IReturnObject) {
    if (returnObject.ErrorType != ErrorTypeEnum.NoError)
      this.errHandler.emitError(
        returnObject.ErrorMsg,
        "",
        returnObject.ErrorType
      );
    else {
      this.currentList = new Array<AttributeListBE>();
      let that = this;
      this.materialExclusionList = returnObject.DataList;

      returnObject.DataList.forEach(function (item) {
        if (item.Id >= 1) that.currentList.push(item);
      });

      this.attributeDescriptionDisabled = true;

      if (this.attributeDescription.trim().length > 0)
        this.attributeId = this.currentList.find(
          (x) => x.Description == this.attributeDescription.trim()
        ).Id;

      this.isInEditMode = false;
      this.attributeDescription = "";
      this.isDirty = false;
    }
  }

  setAttributeDescriptionInput() {
    let itm: AttributeListBE = this.currentList.find(
      (x) => x.Id == this.attributeId
    );
    this.attributeId = itm.Id;
    this.attributeDescription = "";
    this.attributeActive = true;
    this.attributeDescriptionDisabled = true;
    this.isDirty = true;
  }

  isDescriptionEnabled() {
    if (!this.attributeDescriptionDisabled)
      document.getElementById("attributeDescription").focus();
  }

  // ----------------------------------------------------------
  // info
  // ----------------------------------------------------------
  info(message: string): void {
    this.errHandler.emitError(message, "", ErrorTypeEnum.Info);
  }

  // ----------------------------------------------------------
  // Dialog boxes
  // ----------------------------------------------------------
  openConfirmDeleteDlg() {
    this.errHandler.emitErrorObject(null);
    this.dialogAction = "delete";
    this.dialogBtnType = "danger";
    this.dialogAppliesTo = this.currentListText;
    this.dialogAppliesToId = this.attributeId;
    this.currentDlg = this.modalService.open(this.cdlg, { size: "sm" });
  }

  openValidateErrorDlg() {
    this.errHandler.emitErrorObject(null);
    this.dialogAction = "info";
    this.dialogBtnType = "info";
    this.dialogAppliesTo = this.currentListText;
    this.dialogAppliesToId = this.attributeId;
    this.currentDlg = this.modalService.open(this.cdlg, { size: "sm" });
  }

  onConfirmDlgNotify(command: ConfirmResult): void {
    this.closeDlg();

    if (command.Action == "delete") {
      this.doDelete();
    } else {
      this.closeDlg();
    }
  }

  closeDlg() {
    this.currentDlg.close();
  }

  // ----------------------------------------------------------
  // MISC
  // ----------------------------------------------------------
  setDirty() {
    this.isDirty = true;
  }

  onError(error: ErrorObject) {
    this.errorObj = this.errHandler.getError();
  }

  setDescriptionInputFocus() {
    window.setTimeout(function () {
      document.getElementById("attributeDescription").focus();
    }, 0);
  }

  // ------------------------------------------------------
  //Access rights control
  // ------------------------------------------------------
  isPageAccessible(): boolean {
    return this.user.IsPackagingAdmin || this.user.IsDeveloper;
  }

   getSupplierBySupplierNo(supplierNo: string, extendedSupplierNo: string) {
        if (supplierNo != null) {
            if (supplierNo !== 'undefined') {
                if (supplierNo != "0") {
                    this.showSpinner = true;
                    clearInterval(this.typeDelayTimer);
                    this.errHandler.emitErrorObject(null);
                    this.supplierService.getSupplierBySupplierNo(supplierNo, extendedSupplierNo)
                        .subscribe(returnObject => this.getSupplierBySupplierNoResponse(returnObject));
                }
            }
        }
    }

    getSupplierBySupplierNoResponse(returnObject: IReturnObject) {
        if (returnObject.ErrorType != ErrorTypeEnum.NoError)
            this.errHandler.emitError(returnObject.ErrorMsg, 'SupplierContactComponent.getSupplierBySupplierNoResponse', returnObject.ErrorType);
        else {
            this.selectedSupplierName = returnObject.DataList[0].Supplier;
            this.selectedSupplierId = returnObject.DataList[0].Id;
            this.suppliercontactlist = returnObject.DataList.filter(item => item.Id != returnObject.DataList[0].Id);
            if (this.suppliercontactlist != null)
                this.extendedsuppliername = Array.prototype.map.call(this.suppliercontactlist, s => s.Supplier).join(", ");
            if (returnObject.DataList[0].ContactInfoConfirmationDate != null) {
                this.isSelectedSupplierInfoExpired = this.supplierService.isSupplierInfoValid(returnObject.DataList[0].ContactInfoConfirmationDate)
            }
            else
                this.isSelectedSupplierInfoExpired = true;

            this.getSupplierContacts(this.selectedSupplierId);
            this.showSpinner = false;
        }

        this.viewSupplierListSpinner = false;
    }

    getSupplierContacts(supplierId: number) {
        this.showSpinner = true;
        clearInterval(this.typeDelayTimer);
        this.errHandler.emitErrorObject(null);
        this.supplierContactService.getContacts(supplierId)
            .subscribe(returnObject => this.getSupplierContactsResponse(returnObject));
    }

    getSupplierContactsResponse(returnObject: IReturnObject) {
        if (returnObject.ErrorType != ErrorTypeEnum.NoError)
            this.errHandler.emitError(returnObject.ErrorMsg, 'SupplierContactComponent.getSupplierContactResponse', returnObject.ErrorType);
        if (returnObject.DataList.length > 0) {
            this.supplierContacts = returnObject.DataList;
            this.showSpinner = false;
        }

        else {
            this.showSpinner = false;
        }
        this.isFocusSet = false;
        this.isFocusSet = this.setFocus.to("contactName", this.isFocusSet);
    }

    searchSuppTextChanged() {
        var that = this; // needed to preserve scope reference to this within setinterval function

        if (that.searchSupplierText.length >= 2) {
            that.viewSupplierList = true;

            // If this.typeDelayTimer is not nulll then the  
            // user typed somthing new within time limit so reset timer
            if (that.typeDelayTimer != null)
                clearInterval(that.typeDelayTimer);

            that.typeDelayTimer = setInterval(function () {
                that.loadSupplierList();
            }, that.searchKeyStrokeDelay);
        }
        else {
            that.viewSupplierList = false;
            clearInterval(this.typeDelayTimer);
        }
    }

    startSupplierSearchListWithDelay() {
        var that = this;

        if (!that.viewSupplierList) {
            clearInterval(this.supplierSearchListDelayTimer);
            return;
        }

        if (that.supplierSearchListDelayTimer != null)
            clearInterval(that.supplierSearchListDelayTimer);

        that.supplierSearchListDelayTimer = setInterval(function () {
            that.finalizeHideSupplierSearchListWithDelay();
        }, that.searchListDelayTimerDelay);
    }

    finalizeHideSupplierSearchListWithDelay() {
        this.viewSupplierList = false;
        clearInterval(this.supplierSearchListDelayTimer);
    }

    hideSupplierSearchListWithDelay() {
        clearInterval(this.supplierSearchListDelayTimer);
        this.startSupplierSearchListWithDelay();
    }

    showSupplierSearchList() {
        if (this.searchSupplierText.length >= 2) {
            clearInterval(this.supplierSearchListDelayTimer);
            this.viewSupplierList = true;
        }
    }

    loadSupplierList() {
        this.viewSupplierListSpinner = true;
        clearInterval(this.typeDelayTimer);
        this.errHandler.emitErrorObject(null);
        this.supplierService.searchSupplier(this.searchSupplierText)
            .subscribe(returnObject => this.loadSupplierListResponse(returnObject));
    }

    loadSupplierListResponse(returnObject: IReturnObject) {
        if (returnObject.ErrorType != ErrorTypeEnum.NoError)
            this.errHandler.emitError(returnObject.ErrorMsg, 'SupplierContactComponent.loadSupplierListResponse', returnObject.ErrorType);
        else
            this.supplierList = returnObject.DataList;

        this.viewSupplierListSpinner = false;
    }

    selectSupplier(supplier: SupplierListBE) {
        this.supplierContacts = [];
        this.selectedSupplierId = supplier.Id;
        this.selectedSupplierName = supplier.Supplier;
        clearInterval(this.supplierSearchListDelayTimer);

        this.getSupplierContacts(supplier.Id);
    }
}



// WEBPACK FOOTER //
// C:/Users/SHR6M3/Development/PackITWebGui/src/app/packaging-material-attributes/packaging-material-attributes.component.ts